function fn_comp_featuring() {
    $comp = $(".comp_featuring");
    $comp_inner = $comp.find(".featuring");
    $comp_inner.find(".col.l").find(".item-icon").each(function(){
       $(this).clone().prependTo($(this).parent());
    });

    $comp_inner.find(".slider").slick({
        infinite: true,
        arrows: false,
        fade: true,
        dots: false,
        autoplay: true
    });
}